"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsTodayValue = void 0;
const isDateToday_1 = require("./isDateToday");
const getIsTodayValue = ({ date, t, addText, }) => {
    const isToday = (0, isDateToday_1.isDateToday)(date);
    return isToday ? `${t('today')}${addText}` : '';
};
exports.getIsTodayValue = getIsTodayValue;
//# sourceMappingURL=getIsTodayValue.js.map